module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "tipo_pessoa"
    }
  }, [_vm._v("Tipo de pessoa")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_pessoa),
      expression: "dados.tipo_pessoa"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_pessoa", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v("Física")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "J"
    }
  }, [_vm._v("Jurídica")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('cpf_cnpj')
    }
  }, [_c('label', {
    attrs: {
      "for": "cpf_cnpj"
    }
  }, [_vm._v("CPF/CNPJ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['###.###.###-##', '##.###.###/####-##']),
      expression: "['###.###.###-##', '##.###.###/####-##']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cpf_cnpj),
      expression: "dados.cpf_cnpj"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cpf_cnpj",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cpf_cnpj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cpf_cnpj", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cpf_cnpj')),
      expression: "errors.has('cpf_cnpj')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Campo obrigatório")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('nome_razao')
    }
  }, [_c('label', {
    attrs: {
      "for": "nome_razao"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome_razao),
      expression: "dados.nome_razao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "nome_razao",
    staticClass: "form-control",
    attrs: {
      "name": "nome_razao",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome_razao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome_razao", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nome_razao')),
      expression: "errors.has('nome_razao')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Campo obrigatório")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "tel1"
    }
  }, [_vm._v("Telefone 1")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.telefone1),
      expression: "dados.telefone1"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (['(##)####-####', '(##)#####-####']),
      expression: "['(##)####-####','(##)#####-####']"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tel1",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.telefone1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "telefone1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "tel2"
    }
  }, [_vm._v("Telefone 2")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.telefone2),
      expression: "dados.telefone2"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (['(##)####-####', '(##)#####-####']),
      expression: "['(##)####-####','(##)#####-####']"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tel2",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.telefone2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "telefone2", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('cep')
    }
  }, [_c('label', {
    attrs: {
      "for": "cep"
    }
  }, [_vm._v("CEP")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cep),
      expression: "dados.cep"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('#####-###'),
      expression: "'#####-###'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cep",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cep)
    },
    on: {
      "blur": _vm.getEndereco,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cep", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cep')),
      expression: "errors.has('cep')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Campo obrigatório")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('endereco')
    }
  }, [_c('label', {
    attrs: {
      "for": "endereco"
    }
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.endereco),
      expression: "dados.endereco"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "endereco",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.endereco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "endereco", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('endereco')),
      expression: "errors.has('endereco')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Campo obrigatório")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('numero')
    }
  }, [_c('label', {
    attrs: {
      "for": "numero"
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.numero),
      expression: "dados.numero"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "numero_endereco",
    staticClass: "form-control",
    attrs: {
      "name": "numero",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "numero", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numero')),
      expression: "errors.has('numero')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Campo obrigatório")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('complemento')
    }
  }, [_c('label', {
    attrs: {
      "for": "complemento"
    }
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.complemento),
      expression: "dados.complemento"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "complemento",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.complemento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "complemento", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('bairro')
    }
  }, [_c('label', {
    attrs: {
      "for": "bairro"
    }
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.bairro),
      expression: "dados.bairro"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "bairro",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.bairro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "bairro", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bairro')),
      expression: "errors.has('bairro')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Campo obrigatório")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('cidade')
    }
  }, [_c('label', {
    attrs: {
      "for": "cidade"
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.cidade),
      expression: "dados.cidade"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cidade",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.cidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "cidade", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cidade')),
      expression: "errors.has('cidade')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Cidade")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': _vm.errors.has('uf')
    }
  }, [_c('label', {
    attrs: {
      "for": "uf"
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.uf),
      expression: "dados.uf"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "uf",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.uf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "uf", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('uf')),
      expression: "errors.has('uf')"
    }],
    staticClass: "help-block"
  }, [_vm._v("Campo obrigatório")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "tag": "button",
      "to": "/administracao/pessoas"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.salvar()
      }
    }
  }, [_vm._v("Salvar")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Atualização da Pessoa")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d7db268"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administracao/pessoas/form.vue
// module id = 393
// module chunks = 1